// Mock data for Nimoy-Knight Foundation website

export const heroData = {
  logo: "https://static.prod-images.emergentagent.com/jobs/4deff940-82ec-418a-802b-27f3b8967809/images/ee733fa2b8ee14d71baab2df68d023557ef19769e0079d117ba5cb5241cf92cb.png",
  title: "Nimoy-Knight",
  subtitle: "Foundation",
  tagline: "Celebrating Leonard Nimoy's legacy of hope, inspiration, and compassion for all.",
  quote: "A life is like a garden. Perfect moments can be had, but not preserved, except in memory. LLAP"
};

export const navigationItems = [
  { name: "Home", path: "/" },
  { 
    name: "Remembering Leonard", 
    path: "/remembering-leonard",
    hasDropdown: true,
    dropdownItems: [
      { name: "His Life", path: "/remembering-leonard" }
    ]
  },
  { 
    name: "LLAP Award", 
    path: "/llap-tribute",
    hasDropdown: true,
    dropdownItems: [
      { name: "About the Award", path: "/llap-tribute" },
      { name: "Honorees", path: "/honorees" },
      { name: "Nominations", path: "/nominations" }
    ]
  },
  { name: "Special Events", path: "/anniversary" },
  { 
    name: "About", 
    path: "/about",
    hasDropdown: true,
    dropdownItems: [
      { name: "The Foundation", path: "/about" },
      { name: "The Film", path: "/film" },
      { name: "Our Efforts", path: "/initiatives" },
      { name: "Founding Partners", path: "/partners" },
      { name: "In The News", path: "/news" },
      { name: "Brand Resources", path: "/downloads" }
    ]
  }
];

export const missionData = {
  label: "Our Mission",
  title: "Live Long and Prosper",
  description: "The Nimoy-Knight Foundation was established by Leonard Nimoy's daughter Julie Nimoy and filmmaker David Knight to celebrate his remarkable life and share his message of hope, inspiration, and compassion with the world."
};

export const whatWeDoData = {
  label: "What We Do",
  title: "Continuing the Legacy",
  cards: [
    {
      icon: "heart",
      title: "Honoring Leonard",
      description: "Celebrating his remarkable life and the values of hope, logic, and compassion he shared with the world.",
      link: "/remembering-leonard",
      linkText: "Learn more"
    },
    {
      icon: "film",
      title: "The Documentary",
      description: "Watch the powerful documentary about Leonard Nimoy's extraordinary life and lasting legacy.",
      link: "/film",
      linkText: "Learn more"
    },
    {
      icon: "award",
      title: "LLAP Tribute Award",
      description: "Honoring individuals and organizations that embody the spirit of \"Live Long and Prosper.\"",
      link: "/llap-tribute",
      linkText: "Learn more"
    },
    {
      icon: "calendar",
      title: "The Anniversary",
      description: "Join us every February 27th to honor Leonard's memory and celebrate his enduring message of hope.",
      link: "/anniversary",
      linkText: "Learn more"
    }
  ]
};

export const quoteData = {
  quote: "The miracle is this: the more we share, the more we have.",
  author: "Leonard Nimoy"
};

export const galleryImages = [
  {
    src: "https://customer-assets.emergentagent.com/job_llap-foundation-1/artifacts/r3ke2xh3_Screenshot%202026-01-13%20at%206.41.14%E2%80%AFPM.png",
    alt: "Leonard Nimoy in character as Mr. Spock from Star Trek"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_llap-foundation-1/artifacts/jym5put0_Screenshot%202026-01-13%20at%206.45.58%E2%80%AFPM.png",
    alt: "Leonard Nimoy portrait photograph"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_llap-foundation-1/artifacts/dkzzlewo_Screenshot%202026-01-13%20at%206.46.42%E2%80%AFPM.png",
    alt: "Leonard Nimoy behind the scenes on set"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_llap-foundation-1/artifacts/tcoo1k2p_Screenshot%202026-01-13%20at%206.46.52%E2%80%AFPM.png",
    alt: "Leonard Nimoy at a public appearance"
  }
];

export const leonardTimelineData = [
  {
    year: "1931",
    title: "Born in Boston, Massachusetts"
  },
  {
    year: "1966",
    title: "First appears as Mr. Spock in Star Trek"
  },
  {
    year: "1984",
    title: "Directs Star Trek III: The Search for Spock"
  },
  {
    year: "1986",
    title: "Directs Star Trek IV: The Voyage Home"
  },
  {
    year: "2009",
    title: "Appears in J.J. Abrams' Star Trek reboot"
  },
  {
    year: "2015",
    title: "Passes away, leaving an eternal legacy"
  }
];

export const leonardSections = [
  {
    title: "Early Life & Career",
    content: "Leonard Nimoy was born in Boston, Massachusetts to Jewish immigrants from Ukraine. He began acting at age 8 at a local children's theater and went on to study drama at Boston College. His early career included numerous television appearances before landing the role that would define his legacy."
  },
  {
    title: "Mr. Spock: A Cultural Icon",
    content: "In 1966, Nimoy originated the role of Spock in the original Star Trek series created by Gene Roddenberry. The half-human, half-Vulcan science officer became one of the most beloved characters in television history. Nimoy's portrayal of Spock, with his logical demeanor and the iconic Vulcan salute, transcended entertainment to become a cultural phenomenon that inspired generations."
  },
  {
    title: "The Vulcan Salute",
    content: "Leonard Nimoy created the famous Vulcan salute, drawing inspiration from a Jewish blessing he witnessed as a child. The gesture, accompanied by the phrase 'Live Long and Prosper,' has become a universal symbol of goodwill and has been used by people around the world, including astronauts in space."
  },
  {
    title: "Beyond Star Trek",
    content: "Beyond his iconic role as Spock, Nimoy was a Renaissance man. He directed two Star Trek films, including the beloved 'Star Trek IV: The Voyage Home.' He was also an accomplished photographer, poet, and author. His photography work was exhibited in galleries across the country, and he published several books of poetry."
  },
  {
    title: "A Life of Compassion",
    content: "Throughout his life, Leonard Nimoy demonstrated deep compassion for others. He used his platform to advocate for causes he believed in and wasn't afraid to speak openly about personal struggles. His willingness to be vulnerable and authentic inspired countless fans to embrace their own humanity."
  },
  {
    title: "Legacy",
    content: "Leonard Nimoy passed away on February 27, 2015, but his legacy lives on. His final tweet, 'A life is like a garden. Perfect moments can be had, but not preserved, except in memory. LLAP,' continues to inspire millions. The Nimoy-Knight Foundation carries forward his message of hope, compassion, and living life to the fullest."
  }
];

export const donationAmounts = [25, 50, 100, 250, 500];

export const donationLink = "https://secure.givelively.org/donate/aspiritech-nfp/the-nimoy-knight-foundation-remembering-leonard-nimoy";

export const filmData = {
  title: "Remembering Leonard Nimoy: His Life, Legacy and Battle with COPD",
  description: "This powerful documentary, produced by Julie Nimoy and David Knight, celebrates Leonard Nimoy's extraordinary life and career while highlighting his final battle with COPD. The film serves as both a loving tribute and an important educational tool about lung health.",
  year: "2017",
  type: "Feature Length Documentary",
  youtubeId: "tbv36RablVc",
  watchLink: "https://www.copdfoundation.org/Learn-More/Educational-Materials-Resources/Remembering-Leonard-Nimoy-Film.aspx",
  quote: "I think it's my responsibility to take advantage of my position to help people understand what COPD does to you and how difficult it is to live with.",
  features: [
    {
      title: "Produced by Family",
      description: "This powerful documentary was lovingly produced by Leonard's daughter Julie Nimoy and filmmaker David Knight, offering an intimate look at the man behind the legend."
    },
    {
      title: "COPD Awareness",
      description: "Beyond celebrating Leonard's life and career, the film serves as an important educational tool about COPD and lung health, continuing his final mission."
    },
    {
      title: "His Legacy",
      description: "The documentary explores Leonard's extraordinary career spanning over six decades, from his early days in Boston to becoming a cultural icon."
    },
    {
      title: "Beyond Spock",
      description: "Discover Leonard as a director, photographer, poet, and passionate advocate — the many facets of a true Renaissance man."
    }
  ],
  partners: ["American Lung Association", "COPD Foundation"]
};

export const llapRecipients = [
  {
    id: 1,
    name: "Lisa Aziz-Zadeh",
    title: "Professor",
    organization: "University of Southern California",
    image: "https://customer-assets.emergentagent.com/job_llap-foundation-1/artifacts/48r1oiqi_Screenshot%202026-01-13%20at%206.59.44%E2%80%AFPM.png",
    shortQuote: "I am deeply honored to receive the \"Live Long and Prosper\" Tribute Award for my research on the brain-gut-microbiome system in autism. I grew up watching Star Trek and was very inspired by Leonard Nim...",
    fullQuote: "I am deeply honored to receive the \"Live Long and Prosper\" Tribute Award for my research on the brain-gut-microbiome system in autism. I grew up watching Star Trek and was very inspired by Leonard Nimoy's portrayal of Spock. His dedication to logic and compassion has been a guiding principle in my scientific work."
  },
  {
    id: 2,
    name: "Jenson Brooksby",
    title: "Professional Tennis Player & Autism Advocate",
    organization: "ATP Tour",
    image: "https://customer-assets.emergentagent.com/job_llap-foundation-1/artifacts/8wrxbrun_Screenshot%202026-01-13%20at%206.50.09%E2%80%AFPM.png",
    shortQuote: "I am deeply honored and excited to share that I have received the Live Long And Prosper (LLAP) Tribute from the Nimoy-Knight Foundation, recognizing individuals who help create awareness and work to r...",
    fullQuote: "I am deeply honored and excited to share that I have received the Live Long And Prosper (LLAP) Tribute from the Nimoy-Knight Foundation, recognizing individuals who help create awareness and work to reduce the stigma surrounding autism."
  },
  {
    id: 3,
    name: "Maureen Dunne",
    title: "CEO and President",
    organization: "Autism Community Ventures",
    image: "https://dl.dropboxusercontent.com/scl/fi/4rvdnropyyhw1vew14jue/Screenshot-2026-01-12-at-11.04.04-PM.png?rlkey=w7bikaw571jhuvjbdblln3jbg",
    shortQuote: "I'm deeply honored to share that I've been selected as a recipient of the \"Live Long and Prosper\" Tribute Award presented by the Nimoy-Knight Foundation. This recognition carries special meaning for m...",
    fullQuote: "I'm deeply honored to share that I've been selected as a recipient of the \"Live Long and Prosper\" Tribute Award presented by the Nimoy-Knight Foundation. This recognition carries special meaning for me as it celebrates the values of hope, logic, and compassion that Leonard Nimoy embodied."
  },
  {
    id: 4,
    name: "Temple Grandin",
    title: "Professor of Animal Science & Autism Advocate",
    organization: "Colorado State University",
    image: "https://customer-assets.emergentagent.com/job_llap-foundation-1/artifacts/ds657b92_Screenshot%202026-01-13%20at%206.44.24%E2%80%AFPM.png",
    shortQuote: "I am honored to get the 'Live Long & Prosper' Tribute pendant for being a role model and ambassador for the autism community. I have always loved 'Star Trek', and the ethical lessons in the show reall...",
    fullQuote: "I am honored to get the 'Live Long & Prosper' Tribute pendant for being a role model and ambassador for the autism community. I have always loved 'Star Trek', and the ethical lessons in the show really resonated with me."
  },
  {
    id: 5,
    name: "Tim Howe",
    title: "Chief Operating Officer",
    organization: "Spectrum Designs Foundation",
    image: "https://dl.dropboxusercontent.com/scl/fi/qj70fxfdw8e5svj6n4d8h/Screenshot-2026-01-12-at-11.07.50-PM.png?rlkey=xv7y1lxqmdn1hzst9wxcx38yk",
    shortQuote: "I am beyond thrilled to be honored to receive the Live Long & Prosper Tribute Award from the Nimoy-Knight Foundation, for our work at Spectrum Designs Foundation in creating meaningful career paths an...",
    fullQuote: "I am beyond thrilled to be honored to receive the Live Long & Prosper Tribute Award from the Nimoy-Knight Foundation, for our work at Spectrum Designs Foundation in creating meaningful career paths and opportunities for individuals on the autism spectrum."
  },
  {
    id: 6,
    name: "Laura Katz",
    title: "Founder & CEO",
    organization: "Helaina",
    image: "https://dl.dropboxusercontent.com/scl/fi/fz1b8q56bp0pwdvkb5ex7/LauraKatz.png?rlkey=knb6jkqozjjg8tvpzuact7uav",
    shortQuote: "I am honored to receive the \"Live Long and Prosper\" tribute from David Knight and Julie Nimoy with the Nimoy-Knight Foundation. I am proud to wear the necklace that embodies everything Leonard stood f...",
    fullQuote: "I am honored to receive the \"Live Long and Prosper\" tribute from David Knight and Julie Nimoy with the Nimoy-Knight Foundation. I am proud to wear the necklace that embodies everything Leonard stood for — hope, compassion, and the pursuit of knowledge."
  },
  {
    id: 7,
    name: "Tara May",
    title: "CEO",
    organization: "Aspiritech",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop",
    shortQuote: "I wasn't born a Star Trek fan. In fact, I resisted a little. My husband kept at me until I begrudgingly agreed to watch an episode. A single hour turned into an obsession. I became enamored with the c...",
    fullQuote: "I wasn't born a Star Trek fan. In fact, I resisted a little. My husband kept at me until I begrudgingly agreed to watch an episode. A single hour turned into an obsession. I became enamored with the characters and their mission to explore the unknown."
  },
  {
    id: 8,
    name: "Gary Moore",
    title: "Co-Founder & CEO",
    organization: "nonPareil",
    image: "https://dl.dropboxusercontent.com/scl/fi/g1msnyz2ctor27w3u1hir/GaryMoore.JPG?rlkey=uwmyp9d6x3jg5mld9ycbqunvj",
    shortQuote: "I am deeply honored and humbled to receive the Live Long and Prosper Tribute Award from the Nimoy Knight Foundation. My sincere thanks to Julie Nimoy and David Knight for this meaningful recognition a...",
    fullQuote: "I am deeply honored and humbled to receive the Live Long and Prosper Tribute Award from the Nimoy Knight Foundation. My sincere thanks to Julie Nimoy and David Knight for this meaningful recognition and their dedication to continuing Leonard's legacy."
  },
  {
    id: 9,
    name: "Haley Moss",
    title: "Lawyer & Advocate",
    organization: "Inclusion, Autism and Neurodiversity in the Workplace",
    image: "https://dl.dropboxusercontent.com/scl/fi/dpecfs4ni4ifx0lfzalqf/HaleyMoss.png?rlkey=yifh24vhk7rroqa25bupi4d8t",
    shortQuote: "A few years ago, I wrote for StarTrek.com in honor of Autism Acceptance Month about how the show was a lens for so many autistic people to view the world, especially through Mr. Spock. You can only im...",
    fullQuote: "A few years ago, I wrote for StarTrek.com in honor of Autism Acceptance Month about how the show was a lens for so many autistic people to view the world, especially through Mr. Spock. You can only imagine how honored I am to receive this award."
  },
  {
    id: 10,
    name: "Jeff Owens",
    title: "Founder",
    organization: "Autism 101",
    image: "https://dl.dropboxusercontent.com/scl/fi/dtbvh9bivwul7u7td7r61/JeffOwens.png?rlkey=weq76py4gmbu2bknes3d1v2ql",
    shortQuote: "I am deeply honored and, frankly, a bit star-struck to receive the Live Long and Prosper (LLAP) Tribute award from the Nimoy Knight Foundation. This honor feels particularly surreal because it all sta...",
    fullQuote: "I am deeply honored and, frankly, a bit star-struck to receive the Live Long and Prosper (LLAP) Tribute award from the Nimoy Knight Foundation. This honor feels particularly surreal because it all started with my love for Star Trek."
  },
  {
    id: 11,
    name: "Hiren Shukla",
    title: "Global Neurodiversity and Inclusive Value Leader",
    organization: "Ernst & Young",
    image: "https://dl.dropboxusercontent.com/scl/fi/uqc2m0hdyezykdtd0d7dk/HirenShulka.png?rlkey=fgzi9iuhikweq8ufnvvmq492n",
    shortQuote: "\"To Boldly Go Where No One Has Gone Before...\" and to be mentioned with trailblazers like Neil deGrasse Tyson, Temple Grandin, Bill Nye and my good friend Haley Moss. I am blown-away and honored to re...",
    fullQuote: "\"To Boldly Go Where No One Has Gone Before...\" and to be mentioned with trailblazers like Neil deGrasse Tyson, Temple Grandin, Bill Nye and my good friend Haley Moss. I am blown-away and honored to receive this recognition."
  },
  {
    id: 12,
    name: "Robert and Michelle Smigel",
    title: "Founders",
    organization: "NEXT for Autism",
    image: "https://dl.dropboxusercontent.com/scl/fi/hv59rcegk8bt6emmsan72/Smigel.png?rlkey=29k43d1teh8jkovi6ypayf8s3",
    shortQuote: "Mr. Spock and us go way back, and now it's come full circle. My wife Michelle and I are honored to have received the Leonard Nimoy 'Live Long & Prosper' Tribute pendant from his daughter, Julie Nimoy ...",
    fullQuote: "Mr. Spock and us go way back, and now it's come full circle. My wife Michelle and I are honored to have received the Leonard Nimoy 'Live Long & Prosper' Tribute pendant from his daughter, Julie Nimoy, and the Nimoy-Knight Foundation."
  },
  {
    id: 13,
    name: "Richard Spurling",
    title: "Founder & Executive Director",
    organization: "ACEing Autism",
    image: "https://dl.dropboxusercontent.com/scl/fi/c358z0glv7erctfe2glpx/RichardSpurling.png?rlkey=i65f7xir8yyjc23somn99hcj3",
    shortQuote: "Some legacies help us understand each other better. Leonard Nimoy's did exactly that. We are proud to share that Richard Spurling, Founder and Executive Director of ACEing Autism, has been recognized ...",
    fullQuote: "Some legacies help us understand each other better. Leonard Nimoy's did exactly that. We are proud to share that Richard Spurling, Founder and Executive Director of ACEing Autism, has been recognized for his work in the autism community."
  },
  {
    id: 14,
    name: "Jose Velasco",
    title: "SVP, Strategic Operations",
    organization: "Autism Society of America",
    image: "https://dl.dropboxusercontent.com/scl/fi/epn8514t7a9ypgdh9ruqi/JoseVelasco.png?rlkey=yrh5hyazyhhvarswq90jrzpqg",
    shortQuote: "I am deeply honored and profoundly grateful to the Nimoy-Knight Foundation for being presented with the \"Live Long and Prosper\" Tribute award. Leonard Nimoy gave the world more than an iconic characte...",
    fullQuote: "I am deeply honored and profoundly grateful to the Nimoy-Knight Foundation for being presented with the \"Live Long and Prosper\" Tribute award. Leonard Nimoy gave the world more than an iconic character — he gave us a philosophy to live by."
  }
];

export const contactEmail = "info@NimoyKnightFoundation.org";
